import React from 'react';

interface SavedViewMoreIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const SavedViewMoreIcon: React.FC<SavedViewMoreIconProps> = ({
  color = '#909090',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M9.21689 8.0002C9.21689 7.33745 8.67964 6.8002 8.01689 6.8002C7.35415 6.8002 6.81689 7.33745 6.81689 8.0002C6.81689 8.66294 7.35415 9.2002 8.01689 9.2002C8.67964 9.2002 9.21689 8.66294 9.21689 8.0002Z"
      fill="#222222"
    />
    <path
      d="M6.7998 8.0002C6.7998 8.66294 7.33706 9.2002 7.9998 9.2002C8.66255 9.2002 9.1998 8.66294 9.1998 8.0002C9.1998 7.33745 8.66255 6.8002 7.9998 6.8002C7.33706 6.8002 6.7998 7.33745 6.7998 8.0002Z"
      fill={color}
    />
    <path
      d="M9.21689 12.8C9.21689 12.1373 8.67964 11.6 8.01689 11.6C7.35415 11.6 6.81689 12.1373 6.81689 12.8C6.81689 13.4627 7.35415 14 8.01689 14C8.67964 14 9.21689 13.4627 9.21689 12.8Z"
      fill={color}
    />
    <path
      d="M9.1998 12.8C9.1998 12.1373 8.66255 11.6 7.9998 11.6C7.33706 11.6 6.7998 12.1373 6.7998 12.8C6.7998 13.4627 7.33706 14 7.9998 14C8.66255 14 9.1998 13.4627 9.1998 12.8Z"
      fill={color}
    />
    <path
      d="M9.21689 3.20039C9.21689 2.53765 8.67964 2.00039 8.01689 2.00039C7.35415 2.00039 6.81689 2.53765 6.81689 3.20039C6.81689 3.86313 7.35415 4.40039 8.01689 4.40039C8.67964 4.40039 9.21689 3.86313 9.21689 3.20039Z"
      fill={color}
    />
    <path
      d="M9.1998 3.20039C9.1998 2.53765 8.66255 2.00039 7.9998 2.00039C7.33706 2.00039 6.7998 2.53765 6.7998 3.20039C6.7998 3.86313 7.33706 4.40039 7.9998 4.40039C8.66255 4.40039 9.1998 3.86313 9.1998 3.20039Z"
      fill={color}
    />
  </svg>
);

export default SavedViewMoreIcon;
